import initializeJsonFromLocalStorage from "../../../utils/storage/initialize-storage-utils";

const hashUserOccurrences = {
  state: {
    hashUserOccurrences: initializeJsonFromLocalStorage(
      "hash-user-occurrences-data"
    ),
  },
  mutations: {
    setHashUserOccurrencesData(state, data) {
      state.hashUserOccurrences = data;
    },
    clearHashUserOccurrencesData(state) {
      state.hashUserOccurrences = null;
    },
  },
  actions: {
    setStoreHashUserOccurrencesData({ commit }, data) {
      localStorage.setItem("hash-user-occurrences-data", JSON.stringify(data));
      commit("setHashUserOccurrencesData", data);
    },
    clearHashUserOccurrencesData({ commit }) {
      return new Promise((resolve, reject) => {
        try {
          localStorage.setItem("hash-user-occurrences-data", "");
          commit("clearHashUserOccurrencesData");
          resolve();
        } catch (err) {
          reject(err);
        }
      });
    },
  },
  getters: {
    getHashUserOccurrencesData: (state) => state.hashUserOccurrences,
  },
};

export default hashUserOccurrences;
